<template>
  <div class="content Tabs">

     <b-tabs card>

          <b-tab :title="lang.tab_NewPart"  :title-link-class="textColors" :title-item-class="textColors" active >
            <!-- <div v-if="isPlugin">
              <CategoryComponent  :lang="lang.PluginCategory"></CategoryComponent>

            </div> -->
            <NewPartFormComponent :lang="lang.NewPartForm"></NewPartFormComponent>
          </b-tab>

        </b-tabs>

  </div>

</template>
<script>
import { mapGetters } from 'vuex'
//import vSelect from 'vue-select'


import NewPartFormComponent from '@/components/shared/NewPartFormComponent'
import CategoryComponent from '@/components/shared/CategoryComponent'

export default {
  name: "Content",
  components: {
    NewPartFormComponent,
    CategoryComponent
  },
  props:{
    lang: Object
  },
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'isPlugin',
      
    ]),
    textColors(){
      if (this.$store.getters.s_skinVariant == "dark"){
        return ['tabs-bg-dark', 'tabs-text-light']
      }else{
        return ['tabs-bg-light', 'tabs-text-dark']
      }

    }
  },
  created () {


  },
  updated() {


  },
  watch: {

  }
}
</script>

<style scooped>

  #NewPartFormComponent{
    width: 60%;
  }

  .bv-example-row-max{
    max-width: 100%;
    padding-right: 0px;
    padding-left: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PartManager/Views/PartNew/Middle/Content/Content.vue